import React, {useState, useEffect} from 'react';
import managecookies from "../services/managecookies";
import utils from "../services/utils";
import manageareas from "../services/manageareas";
import ConfirmationDialog from "./ConfirmationDialog";

const AreaManage = () => {
        const [areaList, setAreaList] = useState([]);
        const [editingId, setEditingId] = useState(null);
        const [editingName, setEditingName] = useState('');
        const [showConfirm, setShowConfirm] = useState(false);
        const [areaToDelete, setAreaToDelete] = useState(null);
        const [msg, setMsg] = useState(null);
        const [error, setError] = useState('');
        const [newArea, setNewArea] = useState({id: '', name: '', subToID: ''});

        useEffect(() => {
            fetchAreas()
        }, []);

        const fetchAreas = async () => {
            try {
                const areasData = await manageareas.getAllArea();
                // Check if deptsData is truthy and ensure it's an array
                if (areasData) {
                    let areasArray;
                    if (Array.isArray(areasData)) {
                        areasArray = areasData;
                    } else if (typeof areasData === 'object' && areasData !== null) {
                        areasArray = [areasData];
                    } else {
                        areasArray = []; // Set a default value to avoid breaking the application
                    }
                    const sortedAreas = sortAreas(areasArray);
                    setAreaList(sortedAreas);
                }
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };

        const sortAreas = (areas) => {
            const sortedAreas = [];
            console.log(areas)
            areas.forEach(area => {
                if (area.subToID == 0) {
                    sortedAreas.push(area);
                    areas.forEach(subArea => {
                        if (subArea.subToID === area.ID) {
                            sortedAreas.push(subArea);
                        }
                    });
                }
            });
            return sortedAreas;
        };

        const getParentAreaName = (subToID) => {
            const parentArea = areaList.find(area => area.ID === subToID);
            return parentArea ? parentArea.name : '';
        };

        const handleDelete = async (id) => {
            const subAreas = areaList.filter(area => area.subToID === id);
            if (subAreas.length > 0) {
                let text = `${utils.useLang('U_SURE')} ${utils.useLang('HAS_SUB')}`
                subAreas.forEach(subArea=>{
                    text += subArea.name
                })
                setMsg(text)
                setAreaToDelete(id);
                setShowConfirm(true);
            } else {
                await deleteArea(id);
            }
        };

        const deleteArea = async (id) => {
            try {
                const blockedArea = await manageareas.delArea(id);
                if (blockedArea) {
                    fetchAreas();
                }
            } catch (error) {
                console.error('Error deleting area:', error);
            }
        };

        const handleConfirm = async () => {
            await deleteArea(areaToDelete);
            setShowConfirm(false);
            setAreaToDelete(null);
        };

        const handleCancel = () => {
            setShowConfirm(false);
            setAreaToDelete(null);
        };

        const handleEdit = (id, name) => {
            setEditingId(id);
            setEditingName(name);
        };

        const handleBlur = async (id, subId) => {
            const nameExists = areaList.some(area => area.name === editingName && area.ID !== id);
            if (nameExists || editingName.length < 1) {
                setError(utils.useLang('NAME_TAKEN_OR_TOO_SHORT'));
            } else {
                setError('');
                const updatedList = areaList.map(area =>
                    area.ID === id ? {...area, name: editingName} : area
                );
                setAreaList(updatedList);
                try {
                    const editedArea = await manageareas.editArea(id, subId, editingName);
                    if (editedArea) {
                        fetchAreas();
                    }
                } catch (error) {
                    console.error('Error fetching areas:', error);
                }
                setEditingId(null);
            }
        };


        const handleSaveNewArea = async () => {
            const nameExists = areaList.some(area => area.name === newArea.name);
            const nameArea = document.getElementById('newAreaName').value
            if (nameExists || nameArea.length < 1) {
                setError(utils.useLang('NAME_TAKEN_OR_TOO_SHORT'));
            } else {
                setError('');
                try {
                    let isSub = document.getElementById('isSubAreaPick').value
                    const addedArea = await manageareas.addArea(nameArea, isSub);
                    if (addedArea) {
                        fetchAreas();
                    }
                } catch (error) {
                    console.error('Error fetching areas:', error);
                }
            }
        };

        const handleNewAreaChange = (e) => {
            const {name, value} = e.target;
            setNewArea(prevState => ({...prevState, [name]: value}));
        };

        const renderAllMainAreas = () => {
            return areaList.map(area => {
                if (area.subToID == 0) return <option value={area.ID}>{area.name}</option>
            })
        }

        return (
            <div>
                {showConfirm && (
                    <ConfirmationDialog
                        message={msg}
                        onConfirm={handleConfirm}
                        onCancel={handleCancel}
                    />
                )}
                <div  style={{position: 'relative'}}>
                    <div className={'add-area-container'}>
                        <input
                            id="newAreaName"
                            type="text"
                            name="name"
                            placeholder="שם האיזור"
                            value={newArea.name}
                            onChange={handleNewAreaChange}
                        />
                        <select id={'isSubAreaPick'}>
                            <option value={0}>{utils.useLang('MAIN_AREA')}</option>
                            {renderAllMainAreas()}
                        </select>
                        <button onClick={handleSaveNewArea}>{utils.useLang('ADD_AREA')}</button>
                    </div>
                    <div>
                        {error && <p style={{color: 'red'}}>{error}</p>}
                        {areaList.map(area => (
                            <div className={`area-main-container ${area.subToID != 0 ? 'secend-area' : 'main-area'}`} key={area.ID}>
                                {editingId === area.ID ? (
                                    <input
                                        type="text"
                                        value={editingName}
                                        onChange={(e) => setEditingName(e.target.value)}
                                        onBlur={() => handleBlur(area.ID, area.subToID)}
                                        autoFocus
                                    />
                                ) : (
                                    <div> <span onClick={() => handleEdit(area.ID, area.name)}>{area.name}</span>
                                        {area.subToID == 0 ? (
                                            <p>{utils.useLang('MAIN_AREA')}</p>
                                        ) : (
                                            <p>{utils.useLang('SEC_AREA_TO')}: {getParentAreaName(area.subToID)}</p>
                                        )}
                                    </div>
                                )}

                                    <button onClick={() => handleDelete(area.ID)}
                                        style={deleteButtonStyle}>{utils.useLang('DEL')}</button>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        );
    }
;

const deleteButtonStyle = {
    backgroundColor: '#ff4d4d',
    color: 'white',
    border: 'none',
    padding: '5px 10px',
    cursor: 'pointer',
    borderRadius: '5px'
};


export default AreaManage;
